import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { TopBar } from "./TopBar";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { StickyCallBar } from "./StickyCallBar";

let lenis = null;

export const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    lenis = new Lenis({ autoRaf: true, anchors: { offset: -90 }, lerp: 0.1 });
    return () => { lenis?.destroy(); lenis = null; };
  }, []);

  useEffect(() => {
    if (hash) return;
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <>
      <TopBar />
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
      <StickyCallBar />
    </>
  );
};
